export default __webpack_public_path__ + "static/media/meal-lunch-icon.3541fdc3.svg";